module.exports = __webpack_public_path__ + "static/taste-of-boba-tea-success-7bc4e3080bfb75b3bb73fc6389222d90.jpg";